document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("is-product-page")) return;
 
  if (window.innerWidth > 768) return; // only mobile
 
  window.addEventListener("scroll", function () {
    if (window.scrollY > 600) {
      document.body.classList.add("fixed-active");
    } else {
      document.body.classList.remove("fixed-active");
    }
  });
});